var ClosestDivision, Geocoder, getAddressComponentType, getAlternateAddressFormat, presentAddress, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

ClosestDivision = require('./m_closest_division');

presentAddress = require('../helper/m_location_helper').presentAddress;

ref = require('../../general/specialAddressComponentType'), getAddressComponentType = ref.getAddressComponentType, getAlternateAddressFormat = ref.getAlternateAddressFormat;

module.exports = Geocoder = (function() {
  function Geocoder() {
    this._googleGeocodeSuccessHandler = bind(this._googleGeocodeSuccessHandler, this);
  }

  Geocoder.prototype.geocode = function(options) {
    var address, country, current_location, location;
    if (options == null) {
      options = {};
    }
    address = options.address, location = options.location, country = options.country, current_location = options.current_location;
    if (!((address != null) || (location != null))) {
      return;
    }
    ClosestDivision.abort();
    return this.getLatLng({
      address: !current_location ? address : void 0,
      location: current_location ? location : void 0,
      country: country,
      success: _.partial(this._googleGeocodeSuccessHandler, options),
      error: _.partial(this._googleGeocodeErrorHandler, options)
    });
  };

  Geocoder.prototype.getLatLng = function(options) {
    var error, success;
    if (options == null) {
      options = {};
    }
    success = options.success, error = options.error;
    return Groupon.Utils.GoogleMaps.load(function(err) {
      var address, country, location, requestOptions;
      address = options.address, location = options.location, country = options.country, success = options.success, error = options.error;
      if (err != null) {
        return typeof error === "function" ? error() : void 0;
      }
      requestOptions = {
        location: location
      };
      if (address != null) {
        requestOptions = {
          address: address
        };
      }
      if (country !== 'US') {
        requestOptions.componentRestrictions = {
          country: country
        };
      }
      return new window.google.maps.Geocoder().geocode(requestOptions, function(results, status) {
        return typeof success === "function" ? success({
          results: results,
          status: status
        }) : void 0;
      });
    });
  };

  Geocoder.prototype.fetchClosestDivision = function(options) {
    var address, error, lat, lng, success;
    address = options.address, lat = options.lat, lng = options.lng;
    success = _.partial(this._closestDivisionSuccessHandler, options);
    error = _.partial(this._closestDivisionErrorHandler, options);
    return ClosestDivision.getClosestDivision({
      loc: address,
      lat: lat,
      lng: lng,
      success: success,
      error: error
    });
  };

  Geocoder.prototype._googleGeocodeSuccessHandler = function(options, googlegeocoderData) {
    var address, country, current_location, formated_address, friendlyName, geocoderData, geocoderError, lat, lng, ref1, ref2, ref3, ref4, ref5, ref6, ref7, relevantTypes, result, results, status, useAlternateAddressFormat;
    address = options.address, geocoderError = options.geocoderError, country = options.country, current_location = options.current_location;
    results = googlegeocoderData.results, status = googlegeocoderData.status;
    if (status !== 'OK') {
      status = status === 'ZERO_RESULTS' ? 'BAD_LOCATION' : 'UNAVAILABLE';
      return geocoderError({
        address: address,
        status: status
      });
    }
    if (country === 'US' && !current_location) {
      results = _.filter(results, function(arg) {
        var address_components;
        address_components = arg.address_components;
        return _.some(address_components, function(arg1) {
          var short_name;
          short_name = arg1.short_name;
          return short_name === 'US' || short_name === 'CA';
        });
      });
    }
    relevantTypes = function(result) {
      var ref1, ref2, resultTypes;
      resultTypes = ((ref1 = Groupon.LS.data) != null ? (ref2 = ref1.searchBarConfig) != null ? ref2.gmapResultTypes : void 0 : void 0) || ['street_address', 'locality', 'sublocality', 'country', 'political', 'postal_code'];
      return _.some(result.types, function(type) {
        return indexOf.call(resultTypes, type) >= 0;
      });
    };
    if (!(result = _.find(results, relevantTypes))) {
      return geocoderError({
        address: address,
        status: 'BAD_LOCATION'
      });
    }
    useAlternateAddressFormat = ((ref1 = Groupon.LS.flags) != null ? ref1.useAlternateAddressFormat : void 0) || false;
    formated_address = !useAlternateAddressFormat ? result.formatted_address : getAlternateAddressFormat(result);
    friendlyName = presentAddress(formated_address);
    geocoderData = {
      fullAddress: friendlyName,
      friendlyName: friendlyName,
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng(),
      locality: (ref2 = getAddressComponentType(result, 'locality')) != null ? ref2.long_name : void 0,
      administrative_area: (ref3 = getAddressComponentType(result, 'administrative_area_level_1')) != null ? ref3.short_name : void 0,
      sublocality: (ref4 = getAddressComponentType(result, 'sublocality_level_1')) != null ? ref4.short_name : void 0,
      postal_code: (ref5 = getAddressComponentType(result, 'postal_code')) != null ? ref5.short_name : void 0,
      neighborhood: (ref6 = getAddressComponentType(result, 'neighborhood')) != null ? ref6.short_name : void 0,
      types: result.types
    };
    if (current_location) {
      ref7 = options.location, lat = ref7.lat, lng = ref7.lng;
      geocoderData.lat = lat;
      geocoderData.lng = lng;
    }
    lat = geocoderData.lat, lng = geocoderData.lng;
    options = _.extend({}, options, {
      geocoderData: geocoderData,
      lat: lat,
      lng: lng
    });
    return this.fetchClosestDivision(options);
  };

  Geocoder.prototype._googleGeocodeErrorHandler = function(options, status) {
    var geocoderError;
    geocoderError = options.geocoderError;
    if (status === 'abort') {
      return geocoderError({
        status: 'ABORT'
      });
    }
    return geocoderError({
      address: options.address,
      status: 'UNAVAILABLE'
    });
  };

  Geocoder.prototype._closestDivisionSuccessHandler = function(options, response) {
    var address, closestDivision, current_location, geocoderData, geocoderSuccess, lat, lng, locationData, query, ref1;
    address = options.address, query = options.query, geocoderData = options.geocoderData, geocoderSuccess = options.geocoderSuccess, current_location = options.current_location;
    if ((response != null ? response.status : void 0) !== 'ok' && (response.geoData == null)) {
      return options.geocoderError({
        address: address,
        data: geocoderData,
        status: 'BAD_LOCATION'
      });
    }
    ref1 = response.location, lat = ref1.lat, lng = ref1.lng, closestDivision = ref1.closest_division;
    locationData = _.extend({}, geocoderData, {
      lat: lat,
      lng: lng,
      closestDivision: closestDivision
    });
    return geocoderSuccess({
      address: address,
      query: query,
      locationData: locationData,
      current_location: current_location
    });
  };

  Geocoder.prototype._closestDivisionErrorHandler = function(options, xhr, status) {
    var address, error, geocoderData, geocoderError;
    geocoderData = options.geocoderData, address = options.address, geocoderError = options.geocoderError;
    if (status === 'abort') {
      error = {
        status: 'ABORT'
      };
    } else {
      error = {
        address: address,
        data: geocoderData,
        status: 'UNAVAILABLE'
      };
    }
    return geocoderError(error);
  };

  return Geocoder;

})();

//# sourceMappingURL=data:application/json;base64,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
